var ClosestDivision, Geocoder, getAddressComponentType, getAlternateAddressFormat, presentAddress, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

ClosestDivision = require('./m_closest_division');

presentAddress = require('../helper/m_location_helper').presentAddress;

ref = require('../../general/specialAddressComponentType'), getAddressComponentType = ref.getAddressComponentType, getAlternateAddressFormat = ref.getAlternateAddressFormat;

module.exports = Geocoder = (function() {
  function Geocoder() {
    this._googleGeocodeSuccessHandler = bind(this._googleGeocodeSuccessHandler, this);
  }

  Geocoder.prototype.geocode = function(options) {
    var address, country, current_location, location;
    if (options == null) {
      options = {};
    }
    address = options.address, location = options.location, country = options.country, current_location = options.current_location;
    if (!((address != null) || (location != null))) {
      return;
    }
    ClosestDivision.abort();
    return this.getLatLng({
      address: !current_location ? address : void 0,
      location: current_location ? location : void 0,
      country: country,
      success: _.partial(this._googleGeocodeSuccessHandler, options),
      error: _.partial(this._googleGeocodeErrorHandler, options)
    });
  };

  Geocoder.prototype.getLatLng = function(options) {
    var error, success;
    if (options == null) {
      options = {};
    }
    success = options.success, error = options.error;
    return Groupon.Utils.GoogleMaps.load(function(err) {
      var address, country, location, requestOptions;
      address = options.address, location = options.location, country = options.country, success = options.success, error = options.error;
      if (err != null) {
        return typeof error === "function" ? error() : void 0;
      }
      requestOptions = {
        location: location
      };
      if (address != null) {
        requestOptions = {
          address: address
        };
      }
      if (country !== 'US') {
        requestOptions.componentRestrictions = {
          country: country
        };
      }
      return new window.google.maps.Geocoder().geocode(requestOptions, function(results, status) {
        return typeof success === "function" ? success({
          results: results,
          status: status
        }) : void 0;
      });
    });
  };

  Geocoder.prototype.fetchClosestDivision = function(options) {
    var address, error, lat, lng, success;
    address = options.address, lat = options.lat, lng = options.lng;
    success = _.partial(this._closestDivisionSuccessHandler, options);
    error = _.partial(this._closestDivisionErrorHandler, options);
    return ClosestDivision.getClosestDivision({
      loc: address,
      lat: lat,
      lng: lng,
      success: success,
      error: error
    });
  };

  Geocoder.prototype._googleGeocodeSuccessHandler = function(options, googlegeocoderData) {
    var address, country, current_location, formated_address, friendlyName, geocoderData, geocoderError, lat, lng, ref1, ref2, ref3, ref4, ref5, ref6, ref7, relevantTypes, result, results, status, useAlternateAddressFormat;
    address = options.address, geocoderError = options.geocoderError, country = options.country, current_location = options.current_location;
    results = googlegeocoderData.results, status = googlegeocoderData.status;
    if (status !== 'OK') {
      status = status === 'ZERO_RESULTS' ? 'BAD_LOCATION' : 'UNAVAILABLE';
      return geocoderError({
        address: address,
        status: status
      });
    }
    if (country === 'US' && !current_location) {
      results = _.filter(results, function(arg) {
        var address_components;
        address_components = arg.address_components;
        return _.some(address_components, function(arg1) {
          var short_name;
          short_name = arg1.short_name;
          return short_name === 'US' || short_name === 'CA';
        });
      });
    }
    relevantTypes = function(result) {
      var ref1, ref2, resultTypes;
      resultTypes = ((ref1 = Groupon.LS.data) != null ? (ref2 = ref1.searchBarConfig) != null ? ref2.gmapResultTypes : void 0 : void 0) || ['street_address', 'locality', 'sublocality', 'country', 'political', 'postal_code'];
      return _.some(result.types, function(type) {
        return indexOf.call(resultTypes, type) >= 0;
      });
    };
    if (!(result = _.find(results, relevantTypes))) {
      return geocoderError({
        address: address,
        status: 'BAD_LOCATION'
      });
    }
    useAlternateAddressFormat = ((ref1 = Groupon.LS.flags) != null ? ref1.useAlternateAddressFormat : void 0) || false;
    formated_address = !useAlternateAddressFormat ? result.formatted_address : getAlternateAddressFormat(result);
    friendlyName = presentAddress(formated_address);
    geocoderData = {
      fullAddress: friendlyName,
      friendlyName: friendlyName,
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng(),
      locality: (ref2 = getAddressComponentType(result, 'locality')) != null ? ref2.long_name : void 0,
      administrative_area: (ref3 = getAddressComponentType(result, 'administrative_area_level_1')) != null ? ref3.short_name : void 0,
      sublocality: (ref4 = getAddressComponentType(result, 'sublocality_level_1')) != null ? ref4.short_name : void 0,
      postal_code: (ref5 = getAddressComponentType(result, 'postal_code')) != null ? ref5.short_name : void 0,
      neighborhood: (ref6 = getAddressComponentType(result, 'neighborhood')) != null ? ref6.short_name : void 0,
      types: result.types
    };
    if (current_location) {
      ref7 = options.location, lat = ref7.lat, lng = ref7.lng;
      geocoderData.lat = lat;
      geocoderData.lng = lng;
    }
    lat = geocoderData.lat, lng = geocoderData.lng;
    options = _.extend({}, options, {
      geocoderData: geocoderData,
      lat: lat,
      lng: lng
    });
    return this.fetchClosestDivision(options);
  };

  Geocoder.prototype._googleGeocodeErrorHandler = function(options, status) {
    var geocoderError;
    geocoderError = options.geocoderError;
    if (status === 'abort') {
      return geocoderError({
        status: 'ABORT'
      });
    }
    return geocoderError({
      address: options.address,
      status: 'UNAVAILABLE'
    });
  };

  Geocoder.prototype._closestDivisionSuccessHandler = function(options, response) {
    var address, closestDivision, current_location, geocoderData, geocoderSuccess, lat, lng, locationData, query, ref1;
    address = options.address, query = options.query, geocoderData = options.geocoderData, geocoderSuccess = options.geocoderSuccess, current_location = options.current_location;
    if ((response != null ? response.status : void 0) !== 'ok' && (response.geoData == null)) {
      return options.geocoderError({
        address: address,
        data: geocoderData,
        status: 'BAD_LOCATION'
      });
    }
    ref1 = response.location, lat = ref1.lat, lng = ref1.lng, closestDivision = ref1.closest_division;
    locationData = _.extend({}, geocoderData, {
      lat: lat,
      lng: lng,
      closestDivision: closestDivision
    });
    return geocoderSuccess({
      address: address,
      query: query,
      locationData: locationData,
      current_location: current_location
    });
  };

  Geocoder.prototype._closestDivisionErrorHandler = function(options, xhr, status) {
    var address, error, geocoderData, geocoderError;
    geocoderData = options.geocoderData, address = options.address, geocoderError = options.geocoderError;
    if (status === 'abort') {
      error = {
        status: 'ABORT'
      };
    } else {
      error = {
        address: address,
        data: geocoderData,
        status: 'UNAVAILABLE'
      };
    }
    return geocoderError(error);
  };

  return Geocoder;

})();

//# sourceMappingURL=data:application/json;base64,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
